import React from "react";
import SelectablePdfExportMenu from "components/PdfExportMenu";

export const PORTFOLIO_PDF_REPORTS = [
  { value: "overview", label: "Overview" },
  { value: "positions", label: "Positions" },
  { value: "cashFlows", label: "Cash Flows" },
];

export default function PdfExportMenu({ values, onChange, onExport, disabled, generating }) {
  return (
    <SelectablePdfExportMenu
      options={PORTFOLIO_PDF_REPORTS}
      values={values}
      onChange={onChange}
      onExport={onExport}
      disabled={disabled}
      generating={generating}
      title="Choose portfolio reports to export to PDF"
    />
  );
}
